import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
export var ValueProps = function(param) {
    var valueProps = param.valueProps;
    var isSSR = useIsSSR();
    var isMobile = useViewport().isMobile;
    var imageSize = isMobile ? 16 : 24;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: valueProps.map(function(valueProp, index) {
            return valueProp.avatar_image !== undefined ? /*#__PURE__*/ _jsxs(ValuePropsRow, {
                children: [
                    /*#__PURE__*/ _jsx(IconImage, {
                        src: optimizeImageUrlFillSquare(valueProp.avatar_image, isSSR, 48 // standardize size for better resolution
                        ),
                        width: imageSize,
                        height: imageSize
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: isMobile ? "paragraphSansRegular" : "subheadingSansRegular",
                        children: valueProp.description_text
                    })
                ]
            }, index) : null;
        })
    });
};
var IconImage = styled.img.withConfig({
    componentId: "sc-ec38f52d-0"
})([
    "align-self:start;"
]);
var ValuePropsRow = styled(Row).attrs({
    align: "center",
    gap: {
        mobileAndAbove: "1x",
        tabletAndAbove: "2x"
    }
}).withConfig({
    componentId: "sc-ec38f52d-1"
})([
    "",
    "{padding-top:",
    ";}padding-top:",
    ";"
], responsiveMediaQueries.mobile, getSpacing("1x"), getSpacing("2x"));
